module.exports = __webpack_public_path__ + "static/concept3-pc-9d4a8a6a474f0a35be74ef3a5742e7f7.svg";